module.exports = __webpack_public_path__ + "static/media/icon_cross_dark.ccc463e8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icon_cross_dark.svg
// module id = 357
// module chunks = 0